import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import { SupportTicketId as SupportTicketIdSchema } from "@redotech/effect-api-shared/ids/definitions";
import {
  PresenceUserId,
  type PresenceUserId as PresenceUserIdType,
} from "@redotech/effect-api-shared/models/team/presence-notification";
import { queryCollectionOptions } from "@tanstack/query-db-collection";
import { createCollection } from "@tanstack/react-db";
import type { QueryClient } from "@tanstack/react-query";
import { Schema } from "effect";

export const supportTicketPresenceQueryKeys = { all: ["presence"] as const };

export interface SupportTicketPresenceRecord {
  // Composite key: `${supportTicketId}:${userId}`
  id: string;
  supportTicketId: SupportTicketId;
  userId: PresenceUserIdType;
  isViewing: boolean;
  isTyping: boolean;
}

const SupportTicketPresenceRecordSchema = Schema.Struct({
  id: Schema.String,
  supportTicketId: SupportTicketIdSchema,
  userId: PresenceUserId,
  isViewing: Schema.Boolean,
  isTyping: Schema.Boolean,
});

export function createPresenceCollection({
  queryClient,
}: {
  queryClient: QueryClient;
}) {
  return createCollection(
    queryCollectionOptions({
      queryKey: supportTicketPresenceQueryKeys.all,
      queryFn: async (): Promise<SupportTicketPresenceRecord[]> => [],
      getKey: (item) => item.id,
      queryClient,
      syncMode: "on-demand",
      staleTime: Infinity,
      schema: Schema.standardSchemaV1(SupportTicketPresenceRecordSchema),
    }),
  );
}

export type PresenceCollection = ReturnType<typeof createPresenceCollection>;
